import { useEffect } from "react";
import useHandleLogout from "../../../components/hooks/useHandleLogout";

const LogoutPage = () => {
    const logout = useHandleLogout();

    useEffect(() => {
        logout();
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
            <p>Logging out, please wait...</p>
        </div>
    );
};

export default LogoutPage;